import React from 'react';
import Select from '../commons/Select.jsx'
import SidebarFrame from "./SidebarFrame";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";

export default class ElementSettings extends SidebarFrame {


    constructor(props) {
        super(props)
        const arrangement = APP.arrangement;
        const schrank = arrangement.schraenke[arrangement.currentSchrankIndex]
        let index = schrank.elements.indexOf(props.model)
        if (index == -1) index = 0
        this.state = {
            element: index
        }
        APP.model.selectElement(index)
    }

    getSidebarParent() {
        return "korpus";
    }

    renderTitle() {
        return I18N("Elemente");
    }

    selectElement(element) {
        this.setState({element: element})
        APP.model.selectElement(element)
    }

    disableHoehe() {
        return APP.arrangement.selectedSchrank.modell.Name != 'Standard';
    }

    componentWillUnmount() {
        APP.model.selectElement(-1);
    }


    renderBody() {
        // console.log("ELEMENTE RENDER", this.props)
        const arrangement = APP.arrangement;
        const schrank = arrangement.schraenke[arrangement.currentSchrankIndex]
        const element = schrank.elements[this.state.element]
        const select = [];
        for (let i = 1; i <= schrank.elements.length; i++) {
            select.push({value: i - 1, label: i});
        }

        return (
            <div className="appear">
                <Select value={this.state.element} options={select}
                        onChange={value => this.selectElement(parseInt(value))} label={I18N("Element")}/>
                <MeasureNumberInput value={element.size.x}
                                    onBlur={value => APP.model.setBreite(parseInt(value), this.state.element, APP.arrangement.currentSchrankIndex)}
                                    label={I18N("Breite")}/>
                <MeasureNumberInput value={element.getOuterHeight()}
                                    onBlur={value => APP.model.setHoehe(parseInt(value), this.state.element, APP.arrangement.currentSchrankIndex)}
                                    label={I18N("Höhe")} disabled={this.disableHoehe()}/>
                <MeasureNumberInput value={element.size.z}
                                    onBlur={value => APP.model.setTiefe(parseInt(value), this.state.element, APP.arrangement.currentSchrankIndex)}
                                    label={I18N("Nutztiefe")} disabled={true}/>
            </div>
        )
    }
}